import { KastWebSdkClient } from "@kalyzee/kast-web-sdk";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { LoadingView } from "../../components/utils/LoadingView";
import { initEnv } from "../../helpers/env";
import { buildSDKClient } from "../../helpers/sdk";

export interface SdkContextState {
  client: KastWebSdkClient;
}

const SdkContext = React.createContext<SdkContextState | undefined>(undefined);

export interface SdkContextProviderProps {
  children: React.ReactNode;
}

export const useSdkContext: () => SdkContextState = () => {
  const context = useContext(SdkContext);
  if (!context) {
      throw new Error("useSdkContext must be used within an SdkContextProvider");
  }
  return context;
};

export const SdkContextProvider = ({ children }: SdkContextProviderProps) => {
  const [client] = useState<KastWebSdkClient>(() => {
    initEnv();
    return buildSDKClient();
  });

  const state = useMemo<SdkContextState | undefined>(
    () => client ? { client } : undefined,
    [client]
  );

  if (!state) {
    return <LoadingView fullscreen message="Préparation du contexte" />;
  }

  return (
    <SdkContext.Provider value={state}>
      {children}
    </SdkContext.Provider>
  );
};